import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const CollapseWrapper = styled.div`
  height: auto;
  line-height: 28px;
  max-height: ${(props) => (props.isCollapse ? "none" : `58px`)};
  overflow: ${(props) => (props.isCollapse ? "none" : "hidden")};
`;

export const ShowButton = styled.button`
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  color: #ff6f5c;
  background-color: ${colors.WHITE};
  border: none;
  padding: 0;
  margin-top: 5px;
`;
